import type { SVGProps } from 'react';

const SuccessCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    width={40}
    height={40}
    fill="none"
    {...props}
  >
    <path
      d="M33.3337 10L15.0003 28.3333L6.66699 20"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
);

export default SuccessCheck;
